export const environment = {
  production: false,
  env: 'Testing',
  HomeTitle: 'MDM Utilitarios - Testing environment',
  ApiUrl: 'https://gmutlapitest.clavisco.com/',
  recatpchaSiteKey: '6LcEL_EpAAAAAIvuGfcTDMcVd-DZhRdERKZ3HsB-',
  LogRocketId: ''
};
